import PropTypes from "prop-types";
import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

// The banner's look, without any of its rules: what the app shows and what the admin
// settings preview. A full-width strip, so square corners; an admin's line breaks are kept.
export const SystemBannerBar = ({ severity, message, onDismiss, sx }) => {
  const { t } = useTranslation();

  return (
    <Alert
      severity={severity}
      variant="filled"
      // An outage interrupts the screen reader; an announcement waits its turn.
      role={severity === "error" ? "alert" : "status"}
      onClose={onDismiss}
      closeText={t("common.close")}
      data-testid="system-banner"
      sx={[{ borderRadius: 0, whiteSpace: "pre-line", overflowWrap: "anywhere" }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    >
      {message}
    </Alert>
  );
};

SystemBannerBar.propTypes = {
  severity: PropTypes.oneOf(["info", "warning", "error"]).isRequired,
  message: PropTypes.string.isRequired,
  // Shows the close button; leave it out for a banner that can't be dismissed.
  onDismiss: PropTypes.func,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};
